import { PUBLIC_DOMAIN } from '@constants';
import { FeatureType, type HSTitleSetting, type LibItemSysIcon } from '@types';

export const HOTSPOT_MAX = 300;

export const HOTSPOT_SYS_ICONS: Record<FeatureType, LibItemSysIcon> = {
  [FeatureType.scene]: {
    url: '/hotspots/system/changjingqiehuan/qianjin2.png',
    frame: 24,
  },
  [FeatureType.prevScene]: {
    url: '/hotspots/system/changjingqiehuan/qianjin2.png',
    frame: 24,
  },
  [FeatureType.nextScene]: {
    url: '/hotspots/system/changjingqiehuan/qianjin2.png',
    frame: 24,
  },
  [FeatureType.link]: {
    url: '/hotspots/system/chaolianjie/fangdajing.png',
    frame: 24,
  },
  [FeatureType.mobile]: {
    url: '/hotspots/system/dianhua/dianhua2.png',
    frame: 24,
  },
  [FeatureType.map]: { url: '/hotspots/system/daohang/biaoji2.png', frame: 24 },
  [FeatureType.media]: {
    url: '/hotspots/system/tupian/tupian2.png',
    frame: 24,
  },
  [FeatureType.text]: { url: '/hotspots/system/wenzi/wenzi2.png', frame: 24 },
  [FeatureType.article]: {
    url: '/hotspots/system/wenzhang/wenzhang2.png',
    frame: 24,
  },
  [FeatureType.audio]: { url: '/hotspots/system/yinyue/yinyue.png', frame: 24 },
  [FeatureType.video]: {
    url: '/hotspots/system/shiping/shiping2.png',
    frame: 24,
  },
  [FeatureType.seqFrame]: {
    url: '/hotspots/system/zhuzheng/3D.png',
    frame: 24,
  },
  [FeatureType.noFunc]: {
    url: '/hotspots/system/wugongnen/dian.png',
    frame: 24,
  },
  [FeatureType.event]: {
    url: '/hotspots/system/shijian/shijian.png',
    frame: 1,
  },
  [FeatureType.miniProgram]: {
    url: '/hotspots/system/shangye/xiaochengxu1.png',
    frame: 1,
  },
  [FeatureType.doc]: {
    url: '/hotspots/system/wenzi/pdf.png',
    frame: 1,
  },
  [FeatureType.model3d]: {
    url: '/hotspots/system/zhuzheng/zhengfangti4.png',
    frame: 1,
  },
};

export const HOTSPOT_MARK_ICONS: Record<FeatureType, string> = {
  [FeatureType.scene]: '/hotspots/word/changjingqiehuan/1.png',
  [FeatureType.prevScene]:
    '/hotspots/system/changjingqiehuan/shangyichangjin.png',
  [FeatureType.nextScene]:
    '/hotspots/system/changjingqiehuan/xiayichangjin.png',
  [FeatureType.link]: '/hotspots/word/chaolianjie/1.png',
  [FeatureType.mobile]: '/hotspots/word/dianhua/1.png',
  [FeatureType.map]: '/hotspots/word/daohang/1.png',
  [FeatureType.media]: '/hotspots/word/tupian/1.png',
  [FeatureType.text]: '/hotspots/word/wenzi/1.png',
  [FeatureType.article]: '/hotspots/word/wenzhang/1.png',
  [FeatureType.audio]: '/hotspots/word/yinyue/1.png',
  [FeatureType.video]: '/hotspots/word/shiping/1.png',
  [FeatureType.seqFrame]: '/hotspots/word/zhuzheng/1.png',
  [FeatureType.event]: '',
  [FeatureType.noFunc]: '',
  [FeatureType.miniProgram]: '',
  [FeatureType.doc]: '',
  [FeatureType.model3d]: '',
};

export const TITLE_SETTING_DEFAULT: HSTitleSetting = {
  align: 'left',
  edge: 'bottom',
  ox: 0,
  oy: -30,
  font: {
    fontSize: 12,
    fontColor: '255,255,255,1',
  },
  background: {
    type: 0,
    bgColor: '0,0,0,0.5',
    bgRoundedge: 5,
    borderWidth: 0,
    borderColor: '255,255,255,1',
    gradientAngle: 0,
    gradientStartColor: '0,0,0,0.5',
    gradientEndColor: '0,0,0,0.5',
  },
  styleType: 0,
  writingMode: 0,
};

export const IMAGE_PLACEHOLDER = `${PUBLIC_DOMAIN}/imgs/hotspot-image-placeholder.f98716554b021a796e4e1611dff665ca.png`;

export const VIDEO_PLACEHOLDER = `${PUBLIC_DOMAIN}/imgs/hotspot-video-placeholder.89c542ce9bac5dedfe0987ace17ab47a.png`;

export const PM_ID_EDIT = 'polygon_mode_edit';
export const PM_ID_DONE = 'polygon_mode_done';
export const PM_ID_DEL = 'polygon_mode_del';

export const EDITING_ANCHOR = `${PUBLIC_DOMAIN}/imgs/hotspot-anchor.d86b26e2dd4dd9c7aa56351fe4411110.png`;
